import { useMemo } from 'react';
import { useMessages } from 'modules/intl';
import { SmartDiaryEntry } from '../../type';
import { SyncError } from '.';
const timesheetReadOnly = 'READONLY_TIMESHEET';
const timeentryReadOnly = 'READONLY_TIME_ENTRY';
const errorMessages = [
  'smartDiary.errorDialog.syncFailedTitle',
  'smartDiary.errorDialog.timesheetReadonly',
  'smartDiary.errorDialog.timeEntriesReadonly'
];

export const useTimesheetSyncError = (
  errors: SyncError[],
  smartEntries: SmartDiaryEntry[]
): {
  title: string;
  description: string;
  isKnownError: boolean;
  hasTimesheetReadOnlyError: boolean;
  erroredEntries: SmartDiaryEntry[];
  uncategorizedErrors: SyncError[];
} => {
  const uncategorizedErrors = useMemo(
    () =>
      errors.filter(
        (x) => x.code !== timesheetReadOnly && x.code !== timeentryReadOnly
      ),
    [errors]
  );
  const erroredEntries = useMemo(
    () =>
      smartEntries.filter((x) => errors.map((x) => x.id).indexOf(x.id) > -1),
    [smartEntries, errors]
  );

  const hasTimesheetReadOnlyError = useMemo(
    () => errors.some((x: SyncError) => x.code === timesheetReadOnly),
    [errors]
  );

  const hasTimeEntryReadOnlyError = useMemo(
    () => errors.some((x) => x.code === timeentryReadOnly),
    [errors]
  );

  const messages = useMessages(errorMessages, {
    errorCount: errors.length
  });

  const title = useMemo(
    () => messages['smartDiary.errorDialog.syncFailedTitle'],
    [messages]
  );

  const description = useMemo(() => {
    return hasTimesheetReadOnlyError
      ? messages['smartDiary.errorDialog.timesheetReadonly']
      : hasTimeEntryReadOnlyError
      ? messages['smartDiary.errorDialog.timeEntriesReadonly']
      : '';
  }, [hasTimesheetReadOnlyError, hasTimeEntryReadOnlyError, messages]);

  return {
    title,
    description,
    uncategorizedErrors,
    isKnownError: hasTimesheetReadOnlyError || hasTimeEntryReadOnlyError,
    hasTimesheetReadOnlyError,
    erroredEntries: erroredEntries
  };
};
